import React from 'react';
import { L1_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { L1IconType } from '../../types';

const BusinessCategoryL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.923 6.82a1.86 1.86 0 1 0 0 3.721 1.86 1.86 0 0 0 0-3.72"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.512 14.088a4.84 4.84 0 0 0-3.586-1.585c-.884 0-1.712.236-2.426.65"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.187 6.82a1.86 1.86 0 1 1 0 3.721 1.86 1.86 0 0 1 0-3.72"
      vectorEffect="non-scaling-stroke"
    />
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.6 14.088a4.84 4.84 0 0 1 3.585-1.585c.895 0 1.734.242 2.453.665M12.076 9.75a2.875 2.875 0 1 0 0-5.75 2.875 2.875 0 0 0 0 5.75M12.111 12.223a8 8 0 0 0-8 8h16a8 8 0 0 0-8-8"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
BusinessCategoryL1Icon.displayName = 'BusinessCategoryL1Icon';
export default BusinessCategoryL1Icon;
